<template>
<div class="ui_receiveCoupons" v-if="couponsInfo">
    <div class="receiveCoupons">
        <div class="">
            <div class="box">
                <img src="https://xcx.ihotel.cn/hotel/images/couponCenter/couponCloseIcon.png" alt="" class="closeCoupon" @click="closeReceiveCoupons">
                <img src="https://xcx.ihotel.cn/hotel/images/couponCenter/couponHeader.png" alt="" class="boxHeader" @click="closeReceiveCoupons">
                <img src="https://xcx.ihotel.cn/hotel/images/couponCenter/couponTitle.png" alt="" class="couponTitle">
                <p class="title">
                    恭喜您获得{{couponsInfo.associationType == ''?'优惠券':'大礼包'}}
                </p>
                <div class="couponList">
                    <div class="couponBox" v-for="(item , index) in list">
                        <div class="price">
                            ¥<span class='couponNum'>{{item.discountNum}}</span>
                        </div>
                        <div class="info">
                            <p class="desc">{{item.descript}}</p>
                            <p class="limit">{{item.discountTypeName}}{{item.couponTypeName}}</p>
                        </div>
                    </div>
                </div>
                <div class="receiveBtn" @click="receiveTriggerRuleCoupon">
                    立即领取
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import api from "@/utils/api";
import {
    jAlert3,
    jAlert5
} from "@/base/jAlert/jAlert";
import {
    login,
    getWxUserInfo,
    setStorage,
    getStorage
} from "@/utils/wxuser";
var config = {};
var times = null;
export default {
    data() {
        return {
            couponsInfo: {},
            user: getStorage("user"),
            wxuser: getStorage("wxuser"),
            list: [],

            leftTime: 0,
            associatePage: '',
        }
    },
    props: {
        pageName: {
            type: String,
            default () {
                return '';
            }
        },

    },
    methods: {
        getCanTriggerRuleList() {
            this.associatePage = '';
            var path = ''
            if (this.pageName) {
                path = this.pageName
            }
            if(path){
                return;
            }
            
            if (path == 'index') {
                this.associatePage = 'shopIndex';
            } else if (path == 'flash') {
                this.associatePage = 'shopFlash';
            } else if (path == 'blindBox') {
                this.associatePage = 'shopBlind';
            } else if (path == 'firstOrder') {
                this.associatePage = 'shopNew';
            } else if (path.indexOf('presale') != -1) {
                this.associatePage = 'shopBooking';
            } else if (path.indexOf('prePay') != -1) {
                this.associatePage = 'shopAdvance';
            } else if (path.indexOf('employ') != -1) {
                this.associatePage = 'shopStaff';
            }
            let obj = {
                hotelGroupCode: config.hotelGroupCode,
                hotelCode: config.hotelCode,
                scene: 'shop',
                associatePage: this.associatePage,
            }
            if (this.user.cardLevel) {
                obj.cardLevel = this.user.cardLevel;
            }
            api.getCanTriggerRuleList(obj)
                .then((res) => {
                    console.log('=======>getCanTriggerRuleList')
                    console.log(res)
                    if (res.result == 1) {
                        this.couponsInfo = res.retVal[0];
                        if (res.retVal.length) {
                            this.getCanReceiveCouponList()
                        }
                    } else {

                    }
                })
        },
        getCanReceiveCouponList() {
            let obj = {
                hotelGroupCode: config.hotelGroupCode,
                hotelCode: config.hotelCode,
                code: this.couponsInfo.code,
                appid: config.appid,
                memberId: this.user.memberId
            }
            api.canReceiveCouponList(obj)
                .then((res) => {
                    console.log(res)
                    if (res.result == 1) {
                        this.list = res.retVal;
                        this.getReceive();
                    }
                })
        },
        getReceive() {
            if (this.couponsInfo.triggerCode == 'enterPage') {
                this.showReceiveCoupons();
                if (this.couponsInfo.triggerCondition == 'auto') {
                    this.receiveTriggerRuleCoupon();
                }
            } else if (this.couponsInfo.triggerCode == 'browse') {
                this.leftTime = this.couponsInfo.browseDuration;
                this.countdown()
            }

        },
        countdown() {
            var self = this;
            console.log(this.leftTime)
            setTimeout(() => {
                self.leftTime = self.leftTime - 1;
                if (self.leftTime <= 0) {
                    self.showReceiveCoupons();
                    if (self.couponsInfo.triggerCondition == 'auto') {
                        self.receiveTriggerRuleCoupon();
                    }
                    return false;
                } else {
                    var path = ''
                    if (this.pageName) {
                        path = this.pageName
                    }
                    if (path) {
						self.countdown()
                        return false
					}
                   
                    // self.countdown()
                }

            }, 1000)
        },
        showReceiveCoupons() {
            this.$emit('showReceiveCoupons', true)
        },
        closeReceiveCoupons() {
            this.$emit('closeReceiveCoupons', false)
        },
        receiveTriggerRuleCoupon() {
            if (this.couponsInfo.triggerCondition == 'auto') {
                jAlert3('领取成功')
                this.closeReceiveCoupons()
                return false;
            }
            let obj = {
                hotelGroupCode: config.hotelGroupCode,
                hotelGroupId: config.hotelGroupId,
                hotelCode: config.hotelCode,
                hotelId: config.hotelId,
                appid: config.appid,
                code: this.couponsInfo.code,
                memberId: this.user.memberId,
                couponType: this.couponsInfo.associationType || '',
                couponCode: this.couponsInfo.associationCode || '',
                mobile: this.user.mobile || '',
                cardId: this.user.cardId || '',
                cardNo: this.user.cardNo || '',
                cardLevel: this.user.cardLevel || '',
                scene: this.couponsInfo.scene || '',
                shopCouponActivityId: this.couponsInfo.shopCouponActivityId,
            }
            console.log(obj)
            api.receiveTriggerRuleCoupon(obj)
                .then((res) => {
                    console.log(res)
                    if (res.result == 1) {
                        jAlert3(res.msg)
                        this.closeReceiveCoupons()
                    } else {
                        jAlert3(res.msg)
                    }
                })
        },
        byTime() {
            var self = this;
            setTimeout(() => {
                self.leftTime++;
                if (self.leftTime >= self.couponsInfo.browseDuration) {
                    if (this.couponsInfo.triggerCondition == 'auto') {
                        this.receiveTriggerRuleCoupon();
                    } else {
                        this.showReceiveCoupons();
                    }
                } else {
                    self.byTime()
                }
            }, 1000)
        },
    },
    created() {
        config = getStorage("config");
        console.log('=======================>currentRoute')
        console.log(this.$router.currentRoute.path)
        this.getCanTriggerRuleList()
    },

}
</script>

<style lang="less" scoped>
@import url("~@/styles/base.less");
@import url("~@/styles/skin.less");
@import url("~@/styles/mixin.less");

.ui_receiveCoupons {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.6);
    z-index: 9999;

    .receiveCoupons {
        position: absolute;
        top: 50%;
        left: 50%;
        z-index: 99999;
        transform: translate(-50%, -50%);

        .box {
            width: 265px;
            height: 265px;
            padding: 0 6px;
            background-image: linear-gradient(180deg, #FFA264 0%, #F60939 100%);
            border-radius: 12px;
            position: relative;
            z-index: 99999999;
            padding-top: 50px;

            p.title {
                font-family: Alibaba-PuHuiTi-B;
                font-size: 18px;
                color: #FFFFFF;
                letter-spacing: 2px;
                text-align: center;
                line-height: 25px;
                margin-bottom: 12px;
            }

            .closeCoupon {
                width: 30px;
                height: 30px;
                display: block;
                position: absolute;
                right: 0;
                top: -120px;
                z-index: 999;
            }

            .boxHeader {
                position: absolute;
                top: -113px;
                left: 0;
                width: 265px;
            }

            .couponTitle {
                position: absolute;
                width: 126px;
                position: absolute;
                top: 12px;
                left: 50%;
                transform: translate(-50%, 0%);
            }

            .couponList {
                width: 100%;
                padding: 10px 9px;
                background: rgba(255, 255, 255, 0.20);
                border-radius: 8px;
                height: 106px;
                margin-bottom: 14px;

                .couponBox {
                    width: 100%;
                    height: 86px;
                    border-radius: 8px;
                    background-image: url('https://xcx.ihotel.cn/hotel/images/couponCenter/couponImgBox.png');
                    background-size: 100%;
                    display: flex;
                    flex-direction: row;
                    align-items: center;

                    .price {
                        width: 76px;
                        /* height: 86px;

line-height: 86px; */
                        text-align: center;
                        font-family: PingFangSC-Semibold;
                        font-size: 14px;
                        color: #E72E35;

                        .couponNum {
                            font-size: 21px;
                        }
                    }

                    .info {
                        width: 160px;
                        padding: 20px 15px;

                        p.desc {
                            font-family: Alibaba-PuHuiTi-M;
                            font-size: 14px;
                            color: #333333;
                            letter-spacing: 0;
                            margin-bottom: 8px;
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            line-height: 20px;
                        }

                        p.limit {
                            font-family: Alibaba-PuHuiTi-R;
                            font-size: 12px;
                            color: #999999;
                            letter-spacing: 0;
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            line-height: 17px;
                        }
                    }
                }
            }

            .receiveBtn {
                width: 160px;
                height: 38px;
                background-image: linear-gradient(180deg, #FDEC89 0%, #FFAB35 100%);
                border-radius: 22px;
                border-radius: 22px;
                line-height: 38px;
                text-align: center;
                font-family: Alibaba-PuHuiTi-M;
                font-size: 16px;
                color: #6B0012;
                letter-spacing: 0;
                text-align: center;
                margin: 0 auto;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/receiveCoupons.vue